/* Nolae — FAQ (/pages/faq). Built by faq-theme/scripts/build_js.py from the
   prototype's public/ scripts; do not edit by hand. */

/* ————— faq-chrome.js ————— */
/* FAQ — the chrome. A copy of about-us-theme/src/au-chrome.js.
 *
 * What the prototype's public/glass.js did for its own stand-in header, done
 * for the theme's real one — the same approach as the Idol A-Z, Release
 * Calendar and About Us ports:
 *
 *   • the header slides away on a sustained scroll down and comes back on a
 *     longer scroll up, armed only once the hero has scrolled under it;
 *   • --chrome-top tells everything pinned below where to park, which is what
 *     the sticky topic list parks under;
 *   • data-chrome-hold (set by faq.js for the length of a topic jump) keeps
 *     the header away so the jump lands where it was aimed, as glass.js did;
 *   • the theme's header-color-adapt is neutralised (see below).
 *
 * The frosted band is NOT here. The prototype drew its own (body::before, fed
 * by glass.js) because its stand-in header had none; the live theme already
 * runs that exact mechanism — it is the one the prototype's was ported from —
 * and the only chrome this page pins is the header, which is what the theme
 * sizes the band to.
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var header = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  var page = document.querySelector(".nolae-faq");
  if (!page) return;

  var HERO_ENTRY = 0.2;
  var DELTA = 2, HIDE_AFTER = 24, REVEAL_AFTER = 120;
  var up = false, lastY = window.scrollY, run = 0;

  function headerSticky() {
    if (!header) return false;
    var p = getComputedStyle(header).position;
    return p === "sticky" || p === "fixed";
  }

  /* Where the bottom of the pinned chrome is. The story stage pins against
     this, so it has to be published on every scroll, not only when the header
     moves — the header's own position drifts while it is sliding. */
  var lastTop = -1;
  function publishTop() {
    var top = 0;
    if (header && !up && headerSticky()) {
      top = Math.max(0, header.getBoundingClientRect().top) + header.offsetHeight;
    }
    top = Math.round(top);
    if (top !== lastTop) {
      root.style.setProperty("--chrome-top", top + "px");
      lastTop = top;
    }
  }

  /* Armed once the header's bottom edge reaches the hero band's first fifth. */
  function pastHeroEntry() {
    var hero = page.querySelector(".banner");
    if (!hero || !header) return true;
    var r = hero.getBoundingClientRect();
    return r.top + r.height * HERO_ENTRY <= header.offsetHeight;
  }

  function setUp(v) {
    // Never while a theme drawer is open — the cart and menu slide over the page.
    if (v && document.body.classList.contains("lock-all")) v = false;
    if (v === up) return;
    up = v;
    root.classList.toggle("nolae-chrome-up", v);
    publishTop();
    /* The header takes 0.32s to travel. Everything that measures against it —
       the sticky topic list, the current-topic tracking — hears only scroll events, so give
       them three across the transition rather than leaving them a frame
       behind. The prototype's glass.js does the same, for the same reason. */
    [80, 200, 340].forEach(function (ms) {
      setTimeout(function () { window.dispatchEvent(new Event("scroll")); }, ms);
    });
  }

  function autoHide() {
    if (!header) return;
    var y = window.scrollY;
    if (root.hasAttribute("data-chrome-hold")) { lastY = y; run = 0; setUp(true); return; }
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;        // ignore sub-pixel jitter
    lastY = y;
    if (diff > 0 !== run > 0) run = 0;         // direction changed: start a new run
    run += diff;
    if (!pastHeroEntry()) { run = 0; setUp(false); return; }
    if (run >= HIDE_AFTER) setUp(true);
    else if (run <= -REVEAL_AFTER) setUp(false);
  }

  /* ————— Header link colours —————
     The theme's header-color-adapt section, once the header is `scrolled`,
     samples what is behind each nav link and forces it white over a dark patch.
     On this page that misfires the same way it did on the Release Calendar: the
     hero's dark scrim reads as dark, but the header has its own light surface,
     so the links go white on near-white — and the script bails as soon as the
     header un-scrolls without undoing it. Here the header only ever sits over
     the hero or the page's own white, so the theme's own colours are always
     right: whatever the adapter writes is taken straight back off.
     MutationObserver callbacks run before paint, so the white never shows. */
  var adapted = document.querySelectorAll(".header__linklist-link, .header__secondary-links .header__icon-wrapper svg");
  function unadapt(el) { if (el.style.getPropertyValue("color")) el.style.removeProperty("color"); }
  if (adapted.length && window.MutationObserver) {
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) { unadapt(r.target); });
    });
    [].forEach.call(adapted, function (el) {
      unadapt(el);
      mo.observe(el, { attributes: true, attributeFilter: ["style"] });
    });
  }

  function onScroll() { autoHide(); publishTop(); }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", publishTop);
  if (window.ResizeObserver && header) new ResizeObserver(publishTop).observe(header);
  publishTop();
})();

/* ————— blog-split.js ————— */
/* Nolae Blog — per-line split for the section headings' entrance.
 *
 * Ported from the About Us prototype's public/2/hero-split.js. The measuring
 * and rebuilding below are that file's, unchanged; what differs is how groups
 * are chosen. About Us names a fixed list of selectors because it has one of
 * each heading; this page has five section heads, so each [data-split] element
 * is its own group and its lines count 0,1,2… from their own start.
 *
 * ORIGINAL HEADER FOLLOWS
 * ───────────────────────
 * Nolae About Us — per-line split for the hero's entrance.
 *
 * The reference (sendpotion.com) staggers its headline one LINE at a time, each
 * line swinging up out of a backward tilt. Lines are not addressable in CSS, so
 * they have to be made into elements — and where a line breaks depends on the
 * width and on which font is loaded, so it cannot be written into the markup
 * either. This measures the real breaks and wraps them, then re-measures whenever
 * they could have changed.
 *
 * Method: wrap every word in a span, read each one's top, group the spans that
 * share a top into one block per line — then throw the word spans away again,
 * collapsing each line back to plain text. That last step matters for screen
 * readers: a paragraph split into one element per word is read badly by some, and
 * once the lines are known the words have served their purpose. What is left is
 * three blocks of ordinary text.
 *
 * Non-text children survive as single tokens: the inline gif keeps its place
 * mid-sentence, and "K-pop" keeps the nowrap span that stops it breaking at its
 * hyphen.
 *
 * Four groups use this: the hero, which plays on load, and "Meet the team",
 * "Culture at Nolae" and "Content House of K-pop", which each hold until the
 * reader reaches them. The
 * splitting is identical either way — WHEN the lines animate is a CSS question,
 * keyed off a class the relevant section's own script adds.
 *
 * If this never runs, the CSS leaves the hero as plain static text — the entrance
 * is additive, never a precondition for reading the page.
 *
 * Deliberately framework-free (IIFE, no imports, no build step) so it drops into a
 * Shopify Liquid section unchanged:
 *   {{ 'blog-split.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  /* Groups, not one flat list. Each group restarts the stagger index at 0, so
     the team's two blocks count 0,1,2... of their own rather than continuing
     from the hero's — sharing a counter would have handed the team's first line
     a delay several hundred ms long before it even started.
     Within a group the index DOES carry across elements, which is what makes
     the hero's eyebrow and headline read as one run of lines. */
  /* One group per section head. Inside a group the index carries across the
     heading and its blurb, so the two read as one run of lines — exactly as
     [".cult-title", ".cult-blurb"] does on About Us. */
  var GROUP_ROOT = "[data-split]";
  var IN_GROUP = ".row-title, .row-desc, .banner-title, .banner-desc";
  var lastWidth = -1;

  function tokenise(el) {
    // Words become spans; elements pass through whole.
    var tokens = [];
    var nodes = [].slice.call(el.childNodes);
    el.textContent = "";
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        var parts = node.nodeValue.split(/(\s+)/);
        for (var j = 0; j < parts.length; j++) {
          if (!parts[j]) continue;
          if (/^\s+$/.test(parts[j])) {
            // Real whitespace, so the browser still has its break opportunities.
            el.appendChild(document.createTextNode(parts[j]));
          } else {
            var w = document.createElement("span");
            w.textContent = parts[j];
            el.appendChild(w);
            tokens.push(w);
          }
        }
      } else if (node.nodeType === 1) {
        el.appendChild(node);
        tokens.push(node);
      }
    }
    return tokens;
  }

  function split(el, startIndex) {
    /* A re-split (resize, font arrival) of a heading whose entrance has
       already played must not play it again: the rebuilt lines are new
       elements and would restart the keyframe from invisible. */
    var again = el.__orig != null && !!el.closest(".is-arrived");
    if (el.__orig == null) el.__orig = el.innerHTML;
    // Hidden across the rebuild so the un-split text is never painted; both
    // happen in one task, so there is no flash either way.
    el.style.visibility = "hidden";
    el.classList.remove("is-split");
    el.innerHTML = el.__orig;

    var tokens = tokenise(el);
    if (!tokens.length) { el.style.visibility = ""; return startIndex; }

    /* Group into lines by each token's vertical CENTRE, against half a line-height
       of tolerance.
       Not by rect top with a small tolerance, which is the obvious version and is
       wrong here: tokens on one line do not share a top. A word's box is its
       glyphs, the inline gif's is 75px tall and vertically centred, and the two
       differ by enough to look like separate lines — which split the sentence's
       middle line into three and stretched the headline from 234 to 390.
       Centres of tokens on one line agree closely, while the next line's are a
       full line-height away, so half a line-height separates them cleanly whatever
       is sitting in the text. */
    var lh = parseFloat(getComputedStyle(el).lineHeight);
    if (!lh || isNaN(lh)) lh = parseFloat(getComputedStyle(el).fontSize) * 1.3 || 20;
    var tol = lh * 0.5;

    var lines = [];
    var lineCentre = null;
    for (var i = 0; i < tokens.length; i++) {
      var box = tokens[i].getBoundingClientRect();
      /* A token that is not rendered has no position to group by, and its zero
         rect sits nowhere near the real lines — so it would start a line of its
         own. That is not hypothetical: the inline gif is display:none at the
         mobile breakpoint, where it split the middle of the sentence in three and
         left the headline a line taller than it should be. Carry such tokens along
         with whatever line is open instead. */
      if (!box.width && !box.height) {
        if (!lines.length) lines.push([]);
        lines[lines.length - 1].push(tokens[i]);
        continue;
      }
      var centre = box.top + box.height / 2;
      if (lineCentre === null || Math.abs(centre - lineCentre) > tol) {
        lines.push([]);
        lineCentre = centre;
      }
      lines[lines.length - 1].push(tokens[i]);
    }

    // Rebuild as one block per line, collapsing the word spans back to text.
    var frag = document.createDocumentFragment();
    for (var l = 0; l < lines.length; l++) {
      var line = document.createElement("span");
      line.className = "hero-line";
      line.style.setProperty("--i", String(startIndex + l));
      if (again) line.style.animation = "none";
      var group = lines[l];
      for (var t = 0; t < group.length; t++) {
        var tok = group[t];
        /* A <br> did its job during measurement — it is why this group is a
           separate line at all. Carrying it into the rebuilt line would add an
           empty line box below the text and inflate the block's height. */
        if (tok.tagName === "BR") continue;
        var isWord = tok.tagName === "SPAN" && !tok.className;
        if (isWord) {
          var prev = line.lastChild;
          var text = tok.textContent;
          // Put the separating space back between words on the same line.
          if (t > 0) text = " " + text;
          if (prev && prev.nodeType === 3) prev.nodeValue += text;
          else line.appendChild(document.createTextNode(text));
        } else {
          if (t > 0) line.appendChild(document.createTextNode(" "));
          line.appendChild(tok);
        }
      }
      frag.appendChild(line);
    }
    el.textContent = "";
    el.appendChild(frag);

    el.style.visibility = "";
    el.classList.add("is-split");
    return startIndex + lines.length;
  }

  /* `force` re-splits groups already done (line breaks may have moved);
     without it only groups not yet split are touched — which is what lets
     this run twice: once mid-parse for the category rows, and again at
     DOMContentLoaded for the "All articles" head that arrives after them.
     See the note at the top of blog-reveal.js for why the first pass exists. */
  function run(force) {
    var groups = document.querySelectorAll(GROUP_ROOT);
    for (var g = 0; g < groups.length; g++) {
      if (groups[g].__split && !force) continue;
      groups[g].__split = true;
      var index = 0;
      var els = groups[g].querySelectorAll(IN_GROUP);
      for (var i = 0; i < els.length; i++) index = split(els[i], index);
    }
    lastWidth = window.innerWidth;
  }

  function onResize() {
    // Only width can change where a line breaks; height cannot, and on mobile it
    // changes constantly as the address bar comes and goes.
    if (window.innerWidth === lastWidth) return;
    run(true);
  }

  var fontsLoaded = !!(document.fonts && document.fonts.status === "loaded");

  function init() {
    run();
    window.addEventListener("resize", onResize);
    // The fallback face breaks lines somewhere else, so re-split once Omnes
    // lands — unless it already had when the first split was measured.
    if (document.fonts && document.fonts.ready && !fontsLoaded) {
      document.fonts.ready.then(function () { run(true); });
    }
  }

  // First pass right now, mid-parse, for whatever heads already exist; the
  // second at DOMContentLoaded for the rest.
  init();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { run(); });
  }
})();

/* ————— blog-reveal.js ————— */
/* Scroll reveal for the blog index.
 *
 * Vanilla and standalone so it ports to the theme unchanged, as
 * {{ 'blog-reveal.js' | asset_url | script_tag }} — no imports, no build step.
 * Everything carrying [data-reveal] starts hidden in CSS and is released once,
 * the first time it comes near the viewport.
 */
/* Two forms of the attribute, as on About Us /2:
 *
 *   data-reveal=""            fade this element up when it arrives (`is-in`)
 *   data-reveal="<selector>"  add `is-arrived` to this SECTION once the element
 *                             the selector picks comes into view
 *
 * The second is what the split headings key off: the lines live inside the
 * head, but the class that releases them has to land on an ancestor, so the
 * section carries it and names its own trigger.
 */
/* WHEN this runs matters more than what it does. The page is large — every
 * article is in the markup — and the CSS hides each [data-reveal=""] card from
 * the first paint until this script releases it. Loaded at the end of the
 * document, it would not run until the whole thing had parsed, and Safari in
 * particular showed the section titles seconds before their cards. So the
 * page includes it as a plain blocking <script> straight after the category
 * rows: it executes mid-parse, the moment those rows exist, and the cards in
 * view are released at once. Anything parsed later (the "All articles" head)
 * is picked up by the second pass at DOMContentLoaded — scan() only ever
 * observes an element once, so running it twice is safe.
 */
(function () {
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasIO = typeof IntersectionObserver === "function";
  var release = function (section) { section.classList.add("is-arrived"); };

  var aio = hasIO && new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        release(e.target.__section || e.target);
        aio.unobserve(e.target);
      });
    },
    // The same depth the fade below trips at, so every entrance on the page
    // arrives at the same point in the scroll.
    { rootMargin: "0px 0px -8% 0px" }
  );

  var io = hasIO && new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        io.unobserve(e.target); // one-way: nothing re-hides on the way back up
      });
    },
    /* Fires a little before the element arrives, so the motion has finished by
       the time it is properly in view rather than starting there. */
    { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
  );

  function scan() {
    var anchored = document.querySelectorAll("[data-reveal]:not([data-reveal=''])");
    for (var a = 0; a < anchored.length; a++) {
      var section = anchored[a];
      if (section.__seen) continue;
      section.__seen = true;
      var anchor = section.querySelector(section.getAttribute("data-reveal"));
      if (!anchor || !hasIO) { release(section); continue; }
      anchor.__section = section;
      aio.observe(anchor);
    }

    var items = document.querySelectorAll("[data-reveal='']");
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.__seen) continue;
      el.__seen = true;
      /* Reduced motion: show immediately and never observe. The CSS already
         neutralises the transition, but leaving items hidden until an observer
         fires would be worse than not animating at all. */
      if (reduced || !hasIO) el.classList.add("is-in");
      else io.observe(el);
    }
  }

  scan();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
})();

/* ————— faq.js ————— */
/* FAQ — all of the page's behaviour, vanilla, one file (theme: faq.js).
 *
 * Everything works without it: the questions are native <details>, the
 * rail keys are #anchors. This adds:
 *   · animated open/close
 *   · the topic list's current-section highlight (kept in view if the
 *     sidebar has to scroll inside itself on a short screen)
 *   · eased jumps that land just under the header (the Idol A-Z jumpTo)
 *   · #question deep links
 */
(function () {
  "use strict";
  var root = document.documentElement;
  var rail = document.querySelector(".faq-rail");
  var list = document.querySelector(".faq-list");
  if (!rail || !list) return;

  var topics = Array.prototype.slice.call(document.querySelectorAll("[data-faq-topic]"));
  var items = Array.prototype.slice.call(document.querySelectorAll("[data-faq-item]"));
  var keys = Array.prototype.slice.call(document.querySelectorAll("[data-faq-key]"));
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");


  /* ————— Accordion ————— */
  var DURATION = 320, EASE = "cubic-bezier(0.32, 0.72, 0, 1)";

  function setOpen(d, open, animate) {
    var panel = d.querySelector(".faq-a");
    if (d._anim) { d._anim.cancel(); d._anim = null; }
    if (!animate || REDUCED.matches || !panel.animate) {
      d.open = open;
      afterToggle();
      return;
    }
    panel.classList.add("is-animating");
    if (open) {
      d.open = true;
      var h = panel.scrollHeight;
      d._anim = panel.animate([{ height: "0px", opacity: 0 }, { height: h + "px", opacity: 1 }], { duration: DURATION, easing: EASE });
    } else {
      d._anim = panel.animate([{ height: panel.scrollHeight + "px", opacity: 1 }, { height: "0px", opacity: 0 }], { duration: DURATION * 0.8, easing: EASE });
    }
    d._anim.onfinish = function () {
      d._anim = null;
      panel.classList.remove("is-animating");
      if (!open) d.open = false;
      afterToggle();
    };
  }

  function afterToggle() {
    if (window.__lenis && window.__lenis.resize) window.__lenis.resize();
  }

  list.addEventListener("click", function (e) {
    var s = e.target.closest(".faq-q");
    if (!s) return;
    e.preventDefault();
    var d = s.parentElement;
    var opening = !d.open;
    setOpen(d, opening, true);
    if (opening) history.replaceState(history.state, "", withHash(d.id));
  });

  /* ————— Jumps —————
     As on Idol A-Z: the header is asked to stay away for the travel
     (data-chrome-hold, which glass.js honours), so the landing spot is the
     same whichever way the page travelled, and a scroll event is
     dispatched after so glass.js re-evaluates the header. */
  var jumpSeq = 0, jumping = false;
  function jumpTo(el, extra, onDone) {
    if (!el) return;
    root.setAttribute("data-chrome-hold", "");
    window.dispatchEvent(new Event("scroll"));
    var y = Math.max(0, window.scrollY + el.getBoundingClientRect().top - (extra || 10));
    var seq = ++jumpSeq, done = false;
    jumping = true;
    function release() {
      if (done) return;
      done = true;
      if (seq !== jumpSeq) return;
      root.removeAttribute("data-chrome-hold");
      window.dispatchEvent(new Event("scroll"));
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (seq !== jumpSeq) return;
          jumping = false;
          track();
        });
      });
      if (onDone) onDone();
    }
    if (REDUCED.matches) {
      window.scrollTo(0, y);
      setTimeout(release, 50);
    } else if (window.__lenis && window.__lenis.scrollTo) {
      window.__lenis.scrollTo(y, { duration: 0.9, onComplete: release });
      setTimeout(release, 1200);
    } else {
      window.scrollTo({ top: y, behavior: "smooth" });
      setTimeout(release, 800);
    }
  }

  function flash(el) {
    el.classList.remove("is-target");
    void el.offsetWidth;
    el.classList.add("is-target");
  }

  rail.addEventListener("click", function (e) {
    var a = e.target.closest("a.faq-key");
    if (!a) return;
    e.preventDefault();
    var id = a.getAttribute("data-faq-key");
    history.replaceState(history.state, "", withHash(id));
    setActive(id);
    jumpTo(document.getElementById(id), 16);
  });

  /* ————— Current topic —————
     The last section whose top has passed a line a little under the header
     (or under the top edge, once the header has slid away). */
  var current = null;
  function setActive(id) {
    if (id === current) return;
    current = id;
    keys.forEach(function (k) {
      var on = k.getAttribute("data-faq-key") === id;
      if (on) k.setAttribute("aria-current", "true"); else k.removeAttribute("aria-current");
      if (on) keepInView(k);
    });
  }
  /* Only within the sidebar itself, and only if it is scrolling inside its
     own box (a short viewport) — scrollIntoView would also move the page. */
  function keepInView(k) {
    if (rail.scrollHeight <= rail.clientHeight + 1) return;
    var li = k.parentElement;
    var target = li.offsetTop - (rail.clientHeight - li.offsetHeight) / 2;
    rail.scrollTo({ top: Math.max(0, target), behavior: REDUCED.matches ? "auto" : "smooth" });
  }
  var header = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  function track() {
    if (jumping) return;
    var line = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 40;
    var id = null;
    for (var i = 0; i < topics.length; i++) {
      var tp = topics[i];
      if (tp.getBoundingClientRect().top <= line) id = tp.id;
    }
    // Scrolled to the very end: the last topic, even if its top never
    // reached the line.
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
      id = topics[topics.length - 1].id;
    }
    if (id === null) {
      current = null;
      keys.forEach(function (k) { k.removeAttribute("aria-current"); });
      return;
    }
    setActive(id);
  }
  window.addEventListener("scroll", track, { passive: true });
  window.addEventListener("resize", track);

  /* ————— Deep links ————— */
  function withHash(id) {
    var url = new URL(location.href);
    url.hash = id;
    return url.pathname + url.search + url.hash;
  }
  function openFromHash(animate) {
    var id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    if (el.matches("[data-faq-item]")) {
      setOpen(el, true, false);
      jumpTo(el, 16, function () { flash(el); });
    } else if (el.matches("[data-faq-topic]")) {
      setActive(id);
      jumpTo(el, 4);
    }
  }
  window.addEventListener("hashchange", function () { openFromHash(true); });
  // In-answer links to somewhere on this page (#returns) scroll here through
  // the same jump; every other answer link opens in a new tab (answerHtml
  // in lib/faq.ts).
  list.addEventListener("click", function (e) {
    var a = e.target.closest(".faq-a-body a[href^='#']");
    if (!a) return;
    e.preventDefault();
    history.replaceState(history.state, "", withHash(a.getAttribute("href").slice(1)));
    openFromHash(true);
  });


  /* ————— Start ————— */
  if (location.hash) {
    // After layout (fonts, the split headings) has settled.
    setTimeout(function () { openFromHash(false); }, 250);
  }
  track();
})();

/* ————— vimeo-embed.js ————— */
/* Nolae About Us — lazy Vimeo players.
 *
 * Replaces what lazy-video.js used to do for <video data-src>, for the same
 * reasons and with the same thresholds — only the thing being deferred is now
 * a cross-origin player rather than a file.
 *
 * Each embed ships as <iframe data-vimeo="ID"> with NO src, so nothing about
 * Vimeo is fetched — not the player document, not a frame of video — until the
 * clip is within half a screen. That matters more here than it did with files:
 * an unmounted player costs nothing, but eight mounted ones are eight
 * documents each running their own JS.
 *
 * The URL is built here rather than written into the markup so one place owns
 * the flags, and so reduced motion can drop `autoplay` instead of needing a
 * second set of URLs. background=1 is the mode for the clips that are silent
 * forever: no controls, no interaction, autoplay, muted, loop. The testimonial
 * cards need their sound toggled, so they ask for controls=0 and are unmuted
 * through the API by public/testimonials.js.
 *
 * Off-screen players are PAUSED, not unmounted: tearing the iframe down would
 * make coming back a fresh load with a black frame in between. Pausing stops
 * the stream, which is the part worth stopping.
 *
 * player.js is fetched once, on approach, and shared by every embed. Anything
 * needing a Player instance goes through window.__vimeo.player(iframe), which
 * resolves to the same instance however many times it is asked.
 *
 * Deliberately framework-free so it drops into a Liquid section unchanged:
 *   {{ 'vimeo-embed.js' | asset_url | script_tag }}
 *
 * FAQ copy: identical to About Us except the __userPaused check in play().
 */
(function () {
  "use strict";

  var API = "https://player.vimeo.com/api/player.js";
  var frames = [].slice.call(document.querySelectorAll("iframe[data-vimeo]"));
  if (!frames.length) return;

  var still =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var apiPromise = null;
  function api() {
    if (apiPromise) return apiPromise;
    apiPromise = new Promise(function (resolve, reject) {
      if (window.Vimeo && window.Vimeo.Player) return resolve(window.Vimeo);
      var s = document.createElement("script");
      s.src = API;
      s.async = true;
      s.onload = function () { resolve(window.Vimeo); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return apiPromise;
  }

  /* dnt=1 keeps Vimeo from setting cookies or tracking the visitor, which is
     the right default for a clip used as decoration. */
  function url(el) {
    var id = el.getAttribute("data-vimeo");
    var sound = el.hasAttribute("data-sound");
    var p = ["badge=0", "dnt=1", "app_id=58479"];
    if (sound) {
      /* Not background=1: that mode is built to be silent and takes the
         controls away with it. controls=0 gets the same bare frame while
         leaving the audio addressable. */
      p.push("controls=0", "loop=1", "muted=1", "playsinline=1",
             "title=0", "byline=0", "portrait=0");
      p.push(still ? "autoplay=0" : "autoplay=1");
    } else if (still) {
      /* background=1 forces autoplay, so a reader who has asked for less
         motion gets the plain player parked on its first frame instead. */
      p.push("controls=0", "muted=1", "playsinline=1", "autoplay=0",
             "title=0", "byline=0", "portrait=0");
    } else {
      p.push("background=1");
    }
    return "https://player.vimeo.com/video/" + id + "?" + p.join("&");
  }

  /* Clears the blurred placeholder and the spinner — see .v-poster. Applied to
     the BOX rather than the iframe, because those two are its siblings. */
  function live(el) {
    if (el.__live) return;
    el.__live = true;
    if (el.parentElement) el.parentElement.classList.add("is-live");
  }

  function mount(el) {
    if (el.__mounted) return;
    el.__mounted = true;
    el.src = url(el);
    /* If frames never arrive — a blocked embed, a dead connection — stop the
       spinner but keep the poster. A blurred frame reads as intended; a
       spinner still turning reads as broken.

       20s, not 12: a slow phone on a slow connection legitimately takes ten or
       more to bring up a player, and retiring the spinner while it is still
       genuinely working is the worse mistake. Nothing breaks if this fires
       early — the poster stays and the video appears over it when it lands. */
    setTimeout(function () {
      if (!el.__live && el.parentElement) el.parentElement.classList.add("is-quiet");
    }, 20000);
  }

  /* Resolves to the one Player for this iframe, mounting it first if the
     reader has reached for the sound before the clip came into view. */
  function player(el) {
    if (el.__player) return el.__player;
    mount(el);
    el.__player = api().then(function (V) {
      var p = new V.Player(el);
      var seen = function () { live(el); };
      /* Signals that mean FRAMES ARE ON SCREEN, first one wins — live() is
         idempotent. Measured on one embed, from setting src:

             ready         349ms
             loaded        350ms     <- metadata only
             bufferstart   746ms
             playing      1221ms     <- first frame
             timeupdate   1467ms

         `loaded` and `play` are deliberately NOT in this list. `loaded` means
         a video has been loaded, not started, and it lands within a
         millisecond of ready — accepting it cleared the placeholder at 350 and
         revealed a player that painted nothing for another 870ms, which read
         as the video hanging. `play` is the request, not the picture. */
      ["playing", "timeupdate", "bufferend"].forEach(function (ev) {
        try { p.on(ev, seen); } catch (e) { /* unknown event name */ }
      });

      p.ready()
        .then(function () {
          /* Under reduced motion nothing will ever play and the player parks
             on its own first frame, so ready() IS the handover. */
          if (still) { seen(); return; }
          /* Otherwise: ASK, rather than assume. A blind timer here has the
             same fault as `loaded` did — it reveals the player on a guess
             about how long a start takes, and is wrong on a slow connection
             by however long the start actually took. Polling the paused state
             hands over on the player's own account, whenever that is, and
             gives up after ten seconds so a mode that reports nothing at all
             still ends with the spinner retired by is-quiet. */
          var tries = 0;
          var poll = setInterval(function () {
            if (el.__live || ++tries > 40) { clearInterval(poll); return; }
            p.getPaused()
              .then(function (paused) { if (!paused) { clearInterval(poll); seen(); } })
              .catch(function () {});
          }, 250);
        })
        .catch(function () {});
      return p;
    });
    return el.__player;
  }

  function play(el) {
    if (still) return;
    /* FAQ-only addition (the one place this file differs from
       ../about-us/public/2/vimeo-embed.js): the FAQ cards have a pause
       button (public/faq-video.js), and a clip the reader paused must not be
       restarted just because it scrolled back into view. faq-video.js sets
       the flag on pause and clears it on play. */
    if (el.__userPaused) return;
    mount(el);
    player(el).then(function (p) {
      /* ready() first, always. A play() issued before the player has finished
         setting itself up is REJECTED, and since a rejection here is swallowed
         the card would then sit on a black frame indefinitely — which is
         exactly what a first mount looks like, so this is the common case and
         not the edge one. Waiting costs nothing: the clip has its own autoplay
         and is usually already running by the time this resolves.

         Genuine rejections past that point are fine to drop — a policy refusal,
         or the clip having scrolled away again while the call was in flight. */
      return p.ready().then(function () { return p.play(); });
    }).catch(function () {});
  }

  function pause(el) {
    if (!el.__mounted || !el.__player) return;
    el.__player.then(function (p) { p.pause().catch(function () {}); });
  }

  /* player() MOUNTS if it has to, which is right for the card being pressed and
     wrong for the others — silencing a card that was never opened should not
     fetch it. current() answers only for players that already exist. */
  function current(el) { return el.__player || null; }

  window.__vimeo = { player: player, current: current };

  /* Half a screen of lead, matching what the files used to get: enough to have
     buffered before the clip is read, without mounting the whole Culture grid
     at once on a laptop. */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { mount(e.target); play(e.target); }
          else pause(e.target);
        });
      },
      { rootMargin: "50% 0px" }
    );
    frames.forEach(function (f) { io.observe(f); });
  } else {
    frames.forEach(mount);
  }
})();

/* ————— faq-video.js ————— */
/* FAQ — the video cards' controls: sound, play/pause, seek, fullscreen.
 *
 * The SOUND toggle is a port of ../about-us/public/2/testimonials.js (the
 * About Us /2 testimonial video cards): same markup (.tm-card / .tm-play /
 * iframe[data-vimeo]), same rules — on with one press, off with the next,
 * only one card audible at a time, set optimistically and rolled back if
 * Vimeo refuses. About Us looks for its cards inside .tm; these sit inside
 * FAQ answers, so this looks in the whole document.
 *
 * The PLAYBACK controls are the FAQ's addition (.faq-vctl, built in
 * lib/faq.ts): these are how-to clips up to a minute long, not background
 * loops, so a reader needs to pause, scrub and go fullscreen.
 *   · play/pause button. Starting a clip turns its sound ON (and silences
 *     any other card); pausing leaves the sound setting alone.
 *   · a tap on the picture: on a clip playing silently (the muted autoplay)
 *     it turns the sound on; otherwise it plays/pauses like the button.
 *   · seek: a native <input type=range> (0–1000), so drag, tap and
 *     keyboard all work and it is announced as a slider
 *   · time readout (desktop only — the phone card is 169px wide)
 *   · fullscreen: the whole CARD goes fullscreen, so these controls come
 *     with it, and page.css letterboxes the clip instead of cropping. Where
 *     element fullscreen doesn't exist (iPhone Safari), Vimeo's own
 *     requestFullscreen() is used instead.
 *
 * Players still come from vimeo-embed.js, which mounts a clip muted and
 * looping as its answer opens and pauses it as it closes. Two things tie the
 * two files together:
 *   · frame.__userPaused — set here when the READER pauses. vimeo-embed.js
 *     then won't auto-restart that clip when it scrolls back into view, and
 *     the pause doesn't reset the sound (a pause from scrolling away still
 *     does, as on About Us, so nothing comes back audible unasked).
 *   · each card is wired to its player when its answer opens (<details>
 *     toggle), so the controls reflect playback from the first frame.
 *
 * Deliberately framework-free so it drops into a Liquid section unchanged:
 *   {{ 'faq-video.js' | asset_url | script_tag }}
 */
(function () {
  "use strict";

  /* Screen-reader labels. English by default; a page in another language
     sets window.__faqL first (the live theme's per-language snippet does). */
  var L = Object.assign({
    soundOn: "Turn sound on", soundOff: "Turn sound off",
    play: "Play", pause: "Pause",
    fullscreen: "Full screen", exitFullscreen: "Exit full screen",
    of: "{t} of {d}"
  }, window.__faqL || {});

  function noop() {}
  function clock(sec) {
    sec = Math.max(0, Math.floor(sec || 0));
    return Math.floor(sec / 60) + ":" + String(sec % 60).padStart(2, "0");
  }

  function setSound(btn, on) {
    btn.setAttribute("aria-pressed", on ? "true" : "false");
    btn.setAttribute("aria-label", on ? L.soundOff : L.soundOn);
  }

  function init() {
    var vimeo = window.__vimeo;
    if (!vimeo) return; /* nothing to control; the clips still run silently */

    var cards = [].slice.call(document.querySelectorAll(".tm-card--video")).map(function (card) {
      return {
        card: card,
        frame: card.querySelector("iframe[data-vimeo]"),
        sound: card.querySelector(".tm-play"),
        play: card.querySelector(".faq-vplay"),
        seek: card.querySelector(".faq-vseek"),
        now: card.querySelector(".faq-vtime-now"),
        full: card.querySelector(".faq-vfull"),
        duration: parseFloat(card.getAttribute("data-duration")) || 0,
        dragging: false,
        sawEvent: false,
        bound: null,
      };
    }).filter(function (c) { return c.frame; });
    if (!cards.length) return;

    /* ————— wiring a card to its player ————— */
    function setPlaying(c, on) {
      c.card.classList.toggle("is-playing", on);
      if (c.play) c.play.setAttribute("aria-label", on ? L.pause : L.play);
    }
    function showTime(c, sec) {
      var d = c.duration || 0;
      var pct = d ? Math.min(1, sec / d) : 0;
      if (c.seek && !c.dragging) {
        c.seek.value = String(Math.round(pct * 1000));
        c.seek.setAttribute("aria-valuetext", L.of.replace("{t}", clock(sec)).replace("{d}", clock(d)));
      }
      if (c.seek) c.seek.style.setProperty("--p", (c.dragging ? c.seek.value / 10 : pct * 100) + "%");
      if (c.now) c.now.textContent = clock(sec);
    }

    /* One Player per card, events attached once. Resolves to the player. */
    function bind(c) {
      if (c.bound) return c.bound;
      c.bound = vimeo.player(c.frame).then(function (pl) {
        pl.on("play", function () { c.sawEvent = true; c.frame.__userPaused = false; setPlaying(c, true); });
        pl.on("playing", function () { c.sawEvent = true; setPlaying(c, true); });
        pl.on("pause", function () {
          c.sawEvent = true;
          setPlaying(c, false);
          /* A pause from scrolling away / closing the answer silences the card,
             as on About Us; the reader's own pause keeps the sound as it was. */
          if (!c.frame.__userPaused && c.sound && c.sound.getAttribute("aria-pressed") === "true") silence(c);
        });
        pl.on("timeupdate", function (e) {
          if (e && e.duration) c.duration = e.duration;
          showTime(c, e ? e.seconds : 0);
        });
        pl.getDuration().then(function (d) { if (d) c.duration = d; }).catch(noop);
        /* The starting state — but only if no play/pause event has landed in
           the meantime: vimeo-embed.js autoplays at the same moment, and a
           stale "paused" answer arriving after the play event would leave
           the button showing the opposite of what the clip is doing. */
        pl.getPaused().then(function (p) { if (!c.sawEvent) setPlaying(c, !p); }).catch(noop);
        return pl;
      });
      c.bound.catch(function () { c.bound = null; });
      return c.bound;
    }

    /* Wire each card as soon as its answer opens — vimeo-embed.js mounts the
       player at the same moment, so this only attaches listeners to it. */
    cards.forEach(function (c) {
      var d = c.card.closest("details");
      if (!d) return;
      d.addEventListener("toggle", function () { if (d.open) bind(c); });
      if (d.open) bind(c);
    });

    /* ————— sound (About Us testimonials.js) ————— */
    function silence(c) {
      if (!c.sound) return;
      setSound(c.sound, false);
      var p = vimeo.current(c.frame);
      if (p) p.then(function (pl) { pl.setMuted(true).catch(noop); });
    }
    cards.forEach(function (c) {
      if (!c.sound) return;
      c.sound.addEventListener("click", function (e) {
        e.stopPropagation();
        if (c.sound.getAttribute("aria-pressed") === "true") { silence(c); return; }
        soundOnAndPlay(c);
      });
    });

    /* Sound on + play: the sound button's "on", and also what starting a
       clip does (a reader who presses play wants to hear it — user,
       2026-09-28). Only one card is ever audible, so every other card is
       silenced first. Optimistic, rolled back if Vimeo refuses. */
    function soundOnAndPlay(c) {
      cards.forEach(function (o) { if (o !== c) silence(o); });
      if (c.sound) setSound(c.sound, true);
      c.frame.__userPaused = false;
      return bind(c).then(function (pl) {
        return pl.setMuted(false).then(function () { return pl.play(); });
      }).catch(function () { silence(c); });
    }

    /* ————— play / pause ————— */
    function toggle(c) {
      var playing = c.card.classList.contains("is-playing");
      setPlaying(c, !playing); /* optimistic, corrected by the play/pause events */
      if (!playing) {
        /* Starting it: with sound (soundOnAndPlay). */
        soundOnAndPlay(c); /* its catch already rolls back; play/pause events fix the button */
        return;
      }
      bind(c).then(function (pl) {
        c.frame.__userPaused = true;
        return pl.pause();
      }).catch(function () { setPlaying(c, true); });
    }
    cards.forEach(function (c) {
      if (c.play) c.play.addEventListener("click", function (e) { e.stopPropagation(); toggle(c); });
      /* A tap on the picture itself — anything in the card that isn't one of
         the controls. */
      c.card.addEventListener("click", function (e) {
        if (e.target.closest("button, input, a")) return;
        /* Clips autoplay muted as their answer opens, so the first tap on a
           silently playing clip means "let me hear this", not "stop" — it
           turns the sound on and keeps playing (the Instagram/TikTok
           convention). With the sound on, a tap pauses; on a paused clip it
           plays with sound (toggle → soundOnAndPlay). */
        var silent = !c.sound || c.sound.getAttribute("aria-pressed") !== "true";
        if (c.card.classList.contains("is-playing") && silent) { soundOnAndPlay(c); return; }
        toggle(c);
      });
    });

    /* ————— seek ————— */
    cards.forEach(function (c) {
      if (!c.seek) return;
      c.seek.addEventListener("click", function (e) { e.stopPropagation(); });
      c.seek.addEventListener("input", function () {
        c.dragging = true;
        var sec = (c.seek.value / 1000) * (c.duration || 0);
        c.seek.style.setProperty("--p", c.seek.value / 10 + "%");
        if (c.now) c.now.textContent = clock(sec);
      });
      c.seek.addEventListener("change", function () {
        var sec = (c.seek.value / 1000) * (c.duration || 0);
        bind(c).then(function (pl) { return pl.setCurrentTime(sec); })
          .catch(noop)
          .then(function () { c.dragging = false; showTime(c, sec); });
      });
    });

    /* ————— fullscreen ————— */
    function fsElement() { return document.fullscreenElement || document.webkitFullscreenElement || null; }
    function syncFs() {
      var el = fsElement();
      cards.forEach(function (c) {
        var on = el === c.card;
        c.card.classList.toggle("is-fullscreen", on);
        if (c.full) c.full.setAttribute("aria-label", on ? L.exitFullscreen : L.fullscreen);
      });
    }
    document.addEventListener("fullscreenchange", syncFs);
    document.addEventListener("webkitfullscreenchange", syncFs);
    cards.forEach(function (c) {
      if (!c.full) return;
      c.full.addEventListener("click", function (e) {
        e.stopPropagation();
        if (fsElement() === c.card) {
          (document.exitFullscreen || document.webkitExitFullscreen).call(document);
          return;
        }
        var req = c.card.requestFullscreen || c.card.webkitRequestFullscreen;
        if (req) {
          try { var r = req.call(c.card); if (r && r.catch) r.catch(noop); } catch (err) { /* refused */ }
        } else {
          /* iPhone: no element fullscreen — hand it to the player's own. */
          bind(c).then(function (pl) { return pl.requestFullscreen(); }).catch(noop);
        }
      });
    });
  }

  /* init() needs window.__vimeo from vimeo-embed.js. Both load
     afterInteractive, which does not promise an order between them, so if
     this one wins the race it waits for the page's load event (by which
     point every script has run) rather than giving up. */
  var tried = false;
  function start() {
    if (window.__vimeo || tried) { init(); return; }
    tried = true;
    if (document.readyState === "complete") init();
    else window.addEventListener("load", init, { once: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
